import axios from 'axios';

import { XTRAM_BOT_API_URL } from '../../env';

export async function fetchUploadDocument(file, session_id) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post(
    `${XTRAM_BOT_API_URL}/sessions/${encodeURIComponent(session_id)}/documents`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    }
  );

  return response.data;
}

